export var toIntegerFromString = function (value) { return value === '' ? 0 : Number.parseInt(value, 10); };
//# sourceMappingURL=toIntegerFromString.js.map